type WhereFilterMap = Record<string, number>;

export const whereFilterMapOptions: WhereFilterMap = {
  eq: 1,
  neq: 2,
  lt: 3,
  gt: 4,
  lte: 5,
  gte: 6,
  contains: 7,
  doesnotcontain: 8,
  startswith: 9,
  endswith: 10,
  isnull: 11,
  isnotnull: 12,
  isempty: 13,
  isnotempty: 14,
};
